import { hasCapability, type User } from "../base";

export const worksiteView = {
  read: (user: User) => {
    return (
      hasCapability(user, "worksiteView.read") ||
      user.person.regionRoles.includes("REGIONAL_MANAGER") ||
      user.person.regionRoles.includes("CORPORATE_PARTNER_POC")
    );
  },
};
